import { defineStore } from 'pinia'
import { ref } from 'vue'

const formatDate = (date) => {

  const day = ('0' + date.getDate()).slice(-2)
  const month = ('0' + (date.getMonth() + 1)).slice(-2)
  const year = date.getFullYear()

  return `${day}-${month}-${year}`
}

export const useABNCancellationStore = defineStore(
  'abnCancellationStore',
  () => {
    // Store Models
    const abn_cancellation_reason_list = [
      'Business / Enterprise has closed down',
      'Business / Enterprise has never operated',
      'Business / Enterprise has been sold',
      'Business / Enterprise is no longer carried on Australia',
      'Change in Business Structure',
      'Other'
    ]

    const abn_cancellation_day = ref(formatDate(new Date()))
    const abn_cancellation_reason = ref('Business / Enterprise has closed down')
    const other_cancellation_reason = ref('')

    const resetData = () => {
      abn_cancellation_day.value = formatDate(new Date())
      abn_cancellation_reason.value = 'Business / Enterprise has closed down'
      other_cancellation_reason.value = ''
    }

    const update = (order) => {
      abn_cancellation_day.value = order.abn_cancellation.cancellation_day
      abn_cancellation_reason.value = order.abn_cancellation.cancellation_reason
      other_cancellation_reason.value = order.other_cancellation_reason
    }

    return {
      abn_cancellation_reason,
      other_cancellation_reason,
      abn_cancellation_reason_list,
      abn_cancellation_day,
      resetData,
      update
    }
  },
  { persist: true }
)
